/* eslint-disable @typescript-eslint/no-empty-function */
import { ReactElement, useEffect } from "react";
import { Payroll } from "./Payroll";
import { Property } from "../../contexts/properties/logic";
import { useGetUserPropertiesForecastLocksLazyQuery } from "../../__generated__/generated_types";


export interface IWorkflowPayrollWrapper {
    property: Property;
}

export default function WorkflowPayrollWrapper({property}: IWorkflowPayrollWrapper): ReactElement {
    const [getPropertyLocks, {data: propertyLocks}] = useGetUserPropertiesForecastLocksLazyQuery({
        fetchPolicy: "no-cache",
    });

    useEffect(() => {
        getPropertyLocks({
            variables: {
                budgetYear: property.reforecastYear + 1,
            }
        });
    }, [property]);

    if (!propertyLocks?.userPropertiesForecastLocks) {
        return <></>;
    }

    return (
        <Payroll
            setSectionReady={() => {}}
            budgetYear={property.budgetYear}
            lockedProperties={propertyLocks.userPropertiesForecastLocks}
            showSingleProperty={property.id}
            filterPropertyIds={[property.id]}
        />
    );
}
